import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function People() {
  const [emps, setEmps] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/hr/employees").then(r => setEmps(r.data)).catch(() => {}); }, []);
  const filtered = emps.filter(e => !q || (e.name?.toLowerCase().includes(q.toLowerCase()) || e.email?.toLowerCase().includes(q.toLowerCase())));

  return (
    <div className="space-y-6" data-testid="people-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-neutral-500">HR & People</div>
        <h1 className="text-3xl font-bold mt-1">Employees</h1>
        <p className="text-neutral-600 mt-1">{emps.length} people in your organisation.</p>
      </div>
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search employees…" className="pl-9" data-testid="people-search" />
      </div>
      <Card className="border-0 shadow-sm">
        <CardContent className="p-0">
          <table className="w-full text-sm">
            <thead className="text-left text-neutral-500 text-xs uppercase tracking-wider bg-neutral-50">
              <tr>
                <th className="p-4">Name</th><th className="p-4">Role</th><th className="p-4">Department</th><th className="p-4">Location</th><th className="p-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(e => (
                <tr key={e.employee_id} className="border-t" data-testid={`employee-row-${e.employee_id}`}>
                  <td className="p-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-navy text-white grid place-items-center text-xs font-bold">{e.name.split(" ").map(x=>x[0]).join("")}</div>
                      <div><div className="font-medium">{e.name}</div><div className="text-xs text-neutral-500">{e.email}</div></div>
                    </div>
                  </td>
                  <td className="p-4">{e.role_title}</td>
                  <td className="p-4">{e.department}</td>
                  <td className="p-4">{e.location}</td>
                  <td className="p-4"><Badge className={e.status === "ACTIVE" ? "bg-teal text-white border-0" : ""}>{e.status}</Badge></td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-neutral-500">No employees.</td></tr>}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
